import { LeftNav } from "./LeftNav";
import { StatusStrip } from "./StatusStrip";
import { RightRailChat } from "./RightRailChat";
import { CommandPalette } from "./CommandPalette";
import { Button } from "./ui/button";
import { Sparkles } from "lucide-react";
import { useChat } from "@/lib/ChatContext";
import { cn } from "@/lib/utils";

export function Layout({ children }: { children: React.ReactNode }) {
  const { open, toggle } = useChat();

  return (
    <>
    <CommandPalette />
    <div className="grid h-screen w-screen grid-cols-[208px_1fr] grid-rows-[44px_1fr] overflow-hidden">
      {/* status strip spans both columns */}
      <div className="col-span-2 row-start-1 row-end-2 border-b border-border bg-card/40 backdrop-blur">
        <StatusStrip />
      </div>

      <aside className="row-start-2 border-r border-border bg-card/30">
        <LeftNav />
      </aside>

      <main
        className={cn(
          "row-start-2 grid min-w-0 grid-rows-[1fr] overflow-hidden",
          open ? "grid-cols-[1fr_380px]" : "grid-cols-[1fr]",
        )}
      >
        <div className="relative min-w-0 overflow-y-auto">
          <div className="mx-auto h-full w-full max-w-[1400px] px-6 py-5">{children}</div>

          {!open ? (
            <Button
              variant="outline"
              size="sm"
              onClick={toggle}
              className="fixed bottom-4 right-4 gap-1.5 shadow-soft"
              title="Ask Kitt (cmd-k)"
            >
              <Sparkles className="h-3.5 w-3.5 text-brand" />
              Ask Kitt
              <span className="kbd ml-2">⌘K</span>
            </Button>
          ) : null}
        </div>

        {open ? (
          <aside className="border-l border-border bg-card/40 min-w-0">
            <RightRailChat />
          </aside>
        ) : null}
      </main>
    </div>
    </>
  );
}
